<section class="a-drs-cell-container flex-v hpct100 pct100 abs l0 t0 bg-white">
    <div class="flex-h-c f14">
        <i class="fas fa-chevron-left poi"
            [ngClass]="{'poi':!previousBtnDisabled,'disabled-text-color pointer-events-none':previousBtnDisabled}"
            (click)="previousMonthList()"></i>
        <div class="f-g f-s tc"><span class="poi a-drs-year-link" (click)="backToYearList()">{{monthList[0]?.value|date:"yyyy"}}</span></div>
        <i class="fas fa-chevron-right poi"
            [ngClass]="{'poi':!nextBtnDisabled,'disabled-text-color pointer-events-none':nextBtnDisabled}"
            (click)="nextMonthList()">
        </i>
    </div>
    <div class="f-g f-s hpct100">
        <ul class="flex-h-c f-wrap hpct100 pct100">
            <li *ngFor="let month of monthList" class="poi"
                [ngClass]="{'a-drs-disabled pointer-events-none':month.value<minDate||month.value>maxDate,'a-drs-active':month.isSelected}">
                <div class="flex-vh-c" (click)="monthClick(month.value)">{{month.value|date:"MMM"}}</div>
            </li>
        </ul>
    </div>
</section>